import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "regenerator-runtime/runtime.js";
import { computed, defineComponent, reactive, toRefs } from "vue";
import { useI18n } from "vue-i18n"; // helpers

import { ModalStatus } from "@/constants/modal";
import { toggleModalVisible } from "@/utils/vue-helpers/modal";
import Products from "@/views/layout/components/footer/modal/Products.vue";
import ModalModule from "@/store/modules/modal";
import customer from "@/assets/images/svg/customer.svg";
import product from "@/assets/images/svg/product.svg";
import analytics from "@/assets/images/svg/analytics.svg";
import report from "@/assets/images/svg/report.svg";
import orders from "@/assets/images/svg/orders.svg";
import POSConfigModule from "@/store/modules/pos-config";
import { openCashDrawer } from "@/utils/helpers/cross-platform";
export default defineComponent({
  name: "Footer",
  components: {
    Products: Products
  },
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var isProdEnv = process.env.VUE_APP_ENV === "prod";
    var iconStyle = "width: 30px; height: 30px; padding-right: 10px;";
    var customerIconContent = customer;
    var customerIconAlt = "customer";
    var productIconContent = product;
    var productIconAlt = "product";
    var reportIconContent = report;
    var reportIconAlt = "report";
    var analyticsIconContent = analytics;
    var analyticsIconAlt = "analytics";
    var orderIconContent = orders;
    var orderIconAlt = "orders";
    var state = reactive({
      onClickProducts: function onClickProducts() {
        ModalModule.setStatus(ModalStatus.Products);
      },
      onClickCustomers: function onClickCustomers() {
        toggleModalVisible(ModalStatus.Customers);
      },
      onClickOrders: function () {
        var _onClickOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  ModalModule.setStatus(ModalStatus.Orders);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onClickOrders() {
          return _onClickOrders.apply(this, arguments);
        }

        return onClickOrders;
      }(),
      onClickCalendar: function () {
        var _onClickCalendar = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  ModalModule.setStatus(ModalStatus.OccupancyCalendar);

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onClickCalendar() {
          return _onClickCalendar.apply(this, arguments);
        }

        return onClickCalendar;
      }(),
      onClickAnalytics: function onClickAnalytics() {
        ModalModule.setStatus(ModalStatus.Analytics);
      },
      onClickReport: function onClickReport() {
        ModalModule.setStatus(ModalStatus.CashierReports);
      },
      onClickOpenDrawer: function onClickOpenDrawer() {
        openCashDrawer();
      }
    });
    var groupId = computed(function () {
      return POSConfigModule.groupId;
    }); // We need to hide reports for Locarno

    var hideReports = computed(function () {
      return [16342, 19017].includes(Number(groupId.value));
    });
    return _objectSpread(_objectSpread({
      t: t
    }, toRefs(state)), {}, {
      iconStyle: iconStyle,
      customerIconContent: customerIconContent,
      customerIconAlt: customerIconAlt,
      productIconContent: productIconContent,
      productIconAlt: productIconAlt,
      orderIconContent: orderIconContent,
      orderIconAlt: orderIconAlt,
      analyticsIconContent: analyticsIconContent,
      analyticsIconAlt: analyticsIconAlt,
      reportIconContent: reportIconContent,
      reportIconAlt: reportIconAlt,
      groupId: groupId,
      hideReports: hideReports
    });
  }
});